import { NavigationLink } from './types/NavigationLink';
import { Translations } from '../localization/translations.d';

export const getNavigationLinks = (translations: Translations): NavigationLink[] => {
  const { route } = translations;
  const myAccountSlug = window.myAccountPageSlug || 'my-account';

  return [
    {
      href: `/${myAccountSlug}/#/${route?.savedArticles}/`,
      class: 'menu-link--saved-articles',
      name: translations?.accountNavigation?.savedArticles ?? 'Saved articles',
      icon: 'bookmark',
    },
    {
      href: `/${myAccountSlug}/#/${route?.followedAuthorsAndTopics}/`,
      class: 'menu-link--followed-authors-topic',
      name: translations?.accountNavigation?.followedAuthorsTopics ?? 'Followed authors and topics',
      icon: 'shortcut',
    },
    {
      href: `/${myAccountSlug}/#/${route?.myNewsletters}/`,
      class: 'menu-link--my-newsletters',
      name: translations?.accountNavigation?.myNewsletters ?? 'My newsletters',
      icon: 'mail',
    },
    {
      href: `/${myAccountSlug}/#/${route?.myOrders}/`,
      class: 'menu-link--my-orders',
      name: translations?.accountNavigation?.orders ?? 'My orders',
      icon: '',
    },
    {
      href: `/${myAccountSlug}/#/${route?.subscriptions}/`,
      class: 'menu-link--subscriptions',
      name: translations?.accountNavigation?.subscriptions ?? 'Subscriptions',
      icon: '',
    },
    {
      href: `/${myAccountSlug}/#/${route?.settings}/`,
      class: 'menu-link--settings',
      name: translations?.accountNavigation?.settings ?? 'Settings',
      icon: '',
    },
  ];
};
